export const PaymentTypeOverrideKey: string = '__&&PaymentProviderType&&__';
